module.exports = __webpack_public_path__ + "media/bg_health_infoanim_anim_men.5d08d524.mp4";